import styled from 'styled-components';

import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';

export const LoyaltyLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 1rem;
  background-color: ${Styles.color.highlight};
`;

export const StyledLogo = styled(LoyaltyRewardsLogo)`
  width: 80%;
`;
